<template>
    <div class="t-document">
        <a href="#" @click.prevent="Click()">
            <div class="t-document__img">
                <img :src="data.preview">
            </div>
        </a>
        <div class="t-document__remove" v-if="isProfile">
            <button class="t-document__del" @click.prevent="DelDocument()">
                <span>Удалить</span>
                <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.99831 1C8.99831 0.447266 8.55105 0 7.99831 0C7.62136 0 7.29324 0.207031 7.12331 0.513672C7.04324 0.658203 6.99831 0.824219 6.99831 1V2H2.99831C2.44558 2 1.99831 2.44727 1.99831 3C1.99831 3.55273 2.44558 4 2.99831 4H7.99831H12.9983C13.551 4 13.9983 3.55273 13.9983 3C13.9983 2.44727 13.551 2 12.9983 2H8.99831V1ZM1.99831 5C1.70144 5 1.42019 5.13086 1.23074 5.35938C1.04128 5.58594 0.961205 5.88672 1.01394 6.17969L1.74245 10.1797L2.46902 14.1797L3.01394 17.1797C3.10183 17.6543 3.51589 18 3.99831 18H11.9983C12.4807 18 12.8948 17.6543 12.9827 17.1797L14.2542 10.1797L14.9827 6.17969C15.012 6.01367 15.0003 5.8457 14.9495 5.68945C14.9104 5.57031 14.8479 5.45703 14.7659 5.35938C14.5764 5.13086 14.2952 5 13.9983 5H1.99831ZM3.56081 9L3.19558 7H12.801L12.4358 9H3.56081ZM4.28738 13L3.9241 11H12.0725L11.7093 13H4.28738ZM4.8323 16L4.65066 15H11.346L11.1643 16H4.8323Z"
                          fill="#52A8F2"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        props: ['data', 'isProfile'],
        methods: {
            ...mapActions('profile', ['LoadDocuments']),
            DelDocument() {
                this.$http.delete('documents/' + this.data.id)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.LoadDocuments({page: this.$route.query.page});
                        }
                    })
            },
            Click() {
                this.$emit('ViewImage')
            }
        }
    }
</script>

<style lang="sass">
    .t-document
        width: 130px
        margin-bottom: 20px
        &__img
            img
                @extend %substrate_transparent
                width: 102px
                height: 144px
                display: flex
                align-items: center
                justify-content: center
                margin-right: 8px
                flex: none
                object-fit: contain
                &:hover
                    background: white
                    box-shadow: $shadow
        &__name
            flex: 1
            font-weight: bold
            line-height: 1.2
            span
                font-weight: normal
                display: block
                margin-top: 4px
                color: $grey
                &._error
                    color: $red
        &__del
            cursor: pointer
            border: 0
            background: transparent
            margin-top: 0
            outline: none
            display: flex
            justify-content: flex-end
            span
                display: none
                font-size: 13px
                color: $grey
                padding-top: 2px
                margin-right: 5px
            svg
                width: 20px
                height: 20px
            &:hover
                span
                    display: block
                svg
                    path
                        fill: $red
        &__remove
            width: 102px
            padding-top: 5px
            text-align: right
            display: flex
            justify-content: flex-end

        @media(max-width: 769px)
            .t-document
                flex-wrap: wrap
                padding: 0
                justify-content: space-between
                &:not(:last-child)
                    margin-bottom: 24px
                &__name
                    width: 100%
                    flex: none
                    order: 3
                    margin-top: 8px
                &__remove
                    width: 102px
                    padding-top: 5px
                    text-align: right
                &__del
                    position: relative
                    top: 0
                    right: 0
                    order: 2
                    margin: 0
</style>


// WEBPACK FOOTER //
// src/vue_components/Doc.vue